import { IsOptional } from 'class-validator';

export class ParameterEditDTO {
    
    @IsOptional()
    value: string;

}
